import { VisualizationAttr } from "../../../CommonElements";
import {
  getStatusDataName,
  STATUS_DATA_TYPE,
} from "../../../Constant/StatusData";

const showDetail = (data, type) => {
  console.log("data", data);
  switch (type) {
    case "transaksi":
      return showTransaksiDetail(data);
    case "realokasi":
      return showRealokasiDetail(data);
    case "umk":
      return showUMKDetail(data);
    case "umo":
      return showUMODetail(data);
    default:
      return "default";
  }
};

const showTransaksiDetail = (data) => {
  return (
    <>
      <VisualizationAttr label={"id"} content={data.id} />
      <VisualizationAttr label={"Diajukan Oleh"} content={data.diajukan_oleh} />
      <VisualizationAttr label={"Dibayar Oleh"} content={data.dibayar_oleh} />
      <VisualizationAttr label={"id Transaksi"} content={data.id_transaksi} />
      <VisualizationAttr label={"DPSJ"} content={data.id_unit_kerja} />
      <VisualizationAttr label={"keterangan"} content={data.keterangan} />
      <VisualizationAttr
        label={"Kode Jenis Pembayaran"}
        content={data.kode_jenis_pembayaran}
      />
      <VisualizationAttr
        label={"Nilai Transaksi"}
        content={data.nilai_transaksi}
      />
      <VisualizationAttr
        label={"Tanggal Diajukan"}
        content={data.tanggal_diajukan}
        isDate
      />
      <VisualizationAttr
        label={"Tanggal Dibayar"}
        content={data.tanggal_dibayar}
        isDate
      />
      <VisualizationAttr
        label={"tanggal Disetujui"}
        content={data.tanggal_disetujui}
        isDate
      />
      <VisualizationAttr
        label={"Tanggal Transaksi"}
        content={data.tanggal_transaksi}
        isDate
      />
      <VisualizationAttr
        label={"Status Transaksi"}
        content={getStatusDataName(
          data.id_status_transaksi,
          STATUS_DATA_TYPE.Transaksi
        )}
      />
    </>
  );
};

const showRealokasiDetail = (data) => {
  return (
    <>
      <VisualizationAttr label={"id"} content={data.id} />
      <VisualizationAttr label={"Diajukan Oleh"} content={data.diajukan_oleh} />
      <VisualizationAttr label={"id Realokasi"} content={data.id_realokasi} />
      <VisualizationAttr label={"Alasan"} content={data.alasan} />
      <VisualizationAttr label={"Alasan"} content={data.alasan} />
      <VisualizationAttr
        label={"Status Realokasi"}
        content={getStatusDataName(
          data.id_status_realokasi,
          STATUS_DATA_TYPE.Realokasi
        )}
      />
      <VisualizationAttr
        label={"Akun"}
        content={data.kd_akun + " - " + data.nm_akun}
      />
      <VisualizationAttr
        label={"Kegiatan"}
        content={data.kd_keg + " - " + data.nm_keg}
      />
      <VisualizationAttr label={"Keterangan"} content={data.keterangan} />
      <VisualizationAttr label={"DPSJ"} content={data.unit_kerja} />
      <VisualizationAttr
        label={"Waktu Pengajuan"}
        content={data.waktu_pengajuan}
        isDate
      />
      <VisualizationAttr
        label={"Nilai Anggaran"}
        content={data.nilai_anggaran}
        isCurrency
      />
    </>
  );
};

const showUMKDetail = (data) => {
  return (
    <>
      <VisualizationAttr label={"pk"} content={data.pk} />
      <VisualizationAttr label={"Diajukan Oleh"} content={data.diajukan_oleh} />
      <VisualizationAttr label={"Dibayar Oleh"} content={data.dibayar_oleh} />
      <VisualizationAttr label={"Dibayarkan ke"} content={data.dibayarkan_ke} />
      <VisualizationAttr
        label={"Disetujui oleh"}
        content={data.disetujui_oleh}
      />
      <VisualizationAttr
        label={"Tanggal dibuat"}
        content={data.date_created}
        isDate
      />
      <VisualizationAttr
        label={"Batas Akhir"}
        content={data.batas_akhir}
        isDate
      />
      <VisualizationAttr
        label={"Status UMK"}
        content={getStatusDataName(data.id_status_umk, STATUS_DATA_TYPE.UMK)}
      />
      <VisualizationAttr label={"ID UMK"} content={data.id_umk} />
      <VisualizationAttr label={"Kode UMK"} content={data.kode_umk} />
      <VisualizationAttr label={"Keterangan"} content={data.keterangan} />
      <VisualizationAttr label={"DPSJ"} content={data.id_unit_kerja} />
      <VisualizationAttr label={"Nilai"} content={data.nilai} isCurrency />
      <VisualizationAttr label={"Vendor"} content={data.vendor} />
    </>
  );
};

const showUMODetail = (data) => {
  return (
    <>
      <VisualizationAttr label={"id"} content={data.id} />
      <VisualizationAttr label={"id"} content={data.id} />
      <VisualizationAttr
        label={"Tanggal dibuat"}
        content={data.date_created}
        isDate
      />
      <VisualizationAttr
        label={"Batas Akhir"}
        content={data.batas_akhir}
        isDate
      />
      <VisualizationAttr
        label={"Untuk Tanggal"}
        content={data.untuk_tanggal}
        isDate
      />
      <VisualizationAttr label={"Diajukan oleh"} content={data.diajukan_oleh} />
      <VisualizationAttr
        label={"Status UMO"}
        content={getStatusDataName(data.id_status_umo, STATUS_DATA_TYPE.UMO)}
      />
      <VisualizationAttr label={"DPSJ"} content={data.id_unit_kerja} />
      <VisualizationAttr label={"Keterangan"} content={data.keterangan} />
      <VisualizationAttr label={"Kode UMO"} content={data.kode_umo} />
      <VisualizationAttr label={"Nilai"} content={data.nilai} isCurrency />
    </>
  );
};

export default showDetail;
